module.exports = __webpack_public_path__ + "img/map-point.4472fdb4.png";